// extracted by mini-css-extract-plugin
export default {"errorMessage":"ResetView-module__errorMessage--ZSV_a","animatedBackground":"ResetView-module__animatedBackground--FKlOE"};